interface Token {
	key:string,
	value:string
}

/**
* @ngdoc filter
* @name phoenix.filter:pxTokenKeyValue
* @kind function
* 
* @description
*   Finds the key and value of a specific token.
*
* @param {searchToken} expression The name of the token to find
* 
* @example
*   <span ng-init="nameString = '[@Name=john]jgaver[/]' " >
*       {{nameString|pxTokenKeyValue:'Action')[0].key}} - {{nameString|pxTokenKeyValue:'Action')[0].value }}
*   </span>
*/
export function TokenKeyValueFilter() {
	return function tokenKeyValueFilterReplace(str:string, searchToken?:string) {
		if (!str || !searchToken) {
			return null;
		}

		// https://regex101.com/r/zl2DnG/2 ('User' used as example searchToken)
		let tokenFindRegex = new RegExp('\\[@' + searchToken + '=(.*?)\\[\/\]', 'g');
		
		// need the regex without the global tag so it stops after one match
		let tokenParseRegex = new RegExp(tokenFindRegex.source);
		let allMatches = str.match(tokenFindRegex);
		if (allMatches === null) {
			return null;
		}

		return allMatches.map(match => {
			let token:Token = {
				key: null,
				value: null
			};
			let capture = tokenParseRegex.exec(match);
			let parts = capture[1].split(']');
			token.key = parts[0];
			token.value = parts[1];
			return token;
		});
	};
}


// WEBPACK FOOTER //
// ./src/phoenix/filters/tokenKeyValue.ts